import React from 'react';
import Toast from '@ntuctech/devex-tangram/Toast';
import { SvgAlert, SvgInfo } from '@ntuctech/devex-tangram/Icon';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../lib/mediaQuery';

const Toster = styled.div`
  > div:nth-child(1) {
    > div:nth-child(1) {
      width: ${(props) => (props.type === 'success' ? '' : '30rem')};
      ${SCREEN_SIZE.Below.Tablet} {
        width: 20rem !important;
      }
    }
  }
  p {
    max-width: 30rem !important;
  }
`;

const TosterComponent = ({
  isError,
  type = 'alert',
  message = 'An unexpected error occurred. Try refreshing the page, then try again. If the issue persists please contact support.',
  icon = <SvgAlert />,
}) => {
  return (
    <>
      {isError && (
        <Toster type={type}>
          <Toast
            data-testid="toster"
            icon={type === 'alert' ? icon : <SvgInfo />}
            type={type}
            message={message}
          />
        </Toster>
      )}
    </>
  );
};

export default TosterComponent;
